import { AxiosError } from "axios";
import { logOut } from "../assets/library";
import { setPopup } from "../store/slices/popupSlice";
import { store } from "../store/store";
import api from "./baseUrl";
import {
  memberEndPoint,
  loginEndPoint,
  studentDetailsEndPoint,
  studentDetails,
  switchStageEndPoint,
  approvalEndPoint,
  recommendUniversityEndPoint,
  searchUniversityEndPoint,
  allListingsEndPoint,
  addToChecklistEndPoint,
  chatDocsDownloadEndPoint,
  editChecklistEndPoint,
  coordinatorStatusSwitchEndPoint,
  fetchAllMsgsEndPoint,
  fetchChatsEndPoint,
  searchChatsEndPoint,
  seenEndPoint,
  postRetriveChatEndPoit,
  postMessageEndPoint,
  revertDecisionEndPoint,
  resultEndPoint,
  googleFirstTimeCalenderEndpoint,
  googleCalenderEventsEndpoint,
  cancellationEndPoint,
  suggestPackageEndPoint,
  verifyOTPEndPoint,
  sendOTPEndPoint,
  googlecodeCalenderEndpoint,
  newStudentsEndPoint,
  deleteRecommendationEndPoint,
  verifyUserEndPoint,
  singleCourceEndpoint,
  singleUniversityEndpoint,
  createBlogEndPoint,
  createCountryEndPoint,
  createTeamEndPoint,
  createUserEndPoint,
  updateUserEndPoint,
  editCountryEndPoint,
  deleteCountryEndPoint,
  facetEndPoint,
  adminStudentsEndPoint,
  adminStudentSearchEndPoint,
  adminStudentDetailsEndPoint,
  adminCounsellorsEndPoint,
  adminStudentTransferEndPoint,
} from "./endPoints";

let token = localStorage.getItem("_auth_token");
const dispatch = store.dispatch;
const AUTH_ERROR_MESSAGES = new Set([
  "Token Verification Failed",
  "jwt malformed",
  "Unauthorised entry",
]);

const clearAuthStorage = () => {
  localStorage.removeItem("_auth_token");
  localStorage.removeItem("role");
};

const getHeaders = () => {
  token = localStorage.getItem("_auth_token");
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return headers;
};

let headers = getHeaders();

const handleApiError = (error: any) => {
  let errorMessage = "Something went wrong";

  if (error && error instanceof AxiosError) {
    const errorResponse = error.response?.data;
    const statusCode = error.response?.status;
    const responseMessage = errorResponse?.message;
    const isAuthMessage = AUTH_ERROR_MESSAGES.has(responseMessage);
    const shouldLogout = statusCode === 401 || isAuthMessage;
    if (
      shouldLogout
    ) {
      errorMessage = responseMessage || "Session expired. Please login again.";
      clearAuthStorage();
      logOut();
      return errorMessage;
    } else {
      errorMessage = errorResponse?.message || errorMessage; // Use specific error message from API response if available
    }
  } else if (error && error instanceof Error) {
    errorMessage = error.message || errorMessage; // Use error message from JavaScript error object
  }
  dispatch(
    setPopup({
      show: true,
      data: {
        container: {
          name: "error",
          data: errorMessage,
          dimensions: {
            width: "350px",
          },
        },
        type: "custom",
      },
    })
  );

  return errorMessage;
};
const authenticateLogin = async (values: object) => {
  try {
    const response = await api.post(loginEndPoint(), values, {
      withCredentials: true,
    });
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const createBlog = async (values: object) => {
  headers = getHeaders();
  
  try {
    const response = await api.post(createBlogEndPoint(), values,
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const createCountry = async (values: object) => {
  headers = getHeaders();
  
  try {
    const response = await api.post(createCountryEndPoint(), values,
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const editCountry = async (values: object,id:string) => {
  headers = getHeaders();
  
  try {
    const response = await api.put(editCountryEndPoint(id), values,
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const deleteCountry = async (id:string) => {
  headers = getHeaders();
  
  try {
    const response = await api.delete(deleteCountryEndPoint(id),
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const createTeam= async (values: object) => {
  headers = getHeaders();
  
  try {
    const response = await api.post(createTeamEndPoint(), values,
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const createUser = async (values: object) => {
  headers = getHeaders();
  
  try {
    const response = await api.post(createUserEndPoint(), values,
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const updateUser = async (values: object) => {
  headers = getHeaders();
  
  try {
    const response = await api.post(updateUserEndPoint(), values,
    headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const persistAccessToken = (responsePayload: any) => {
  const refreshedToken =
    responsePayload?.AccessToken || responsePayload?.data?.AccessToken || "";
  if (refreshedToken) {
    localStorage.setItem("_auth_token", refreshedToken);
  }
};

const getWithFallbackRoutes = async (routes: string[]) => {
  headers = getHeaders();
  let lastError: any = null;
  for (const route of routes) {
    try {
      const response = await api.get(route, headers).then((res) => res?.data);
      persistAccessToken(response);
      return response;
    } catch (err: any) {
      lastError = err;
    }
  }
  throw lastError;
};

const postWithFallbackRoutes = async (routes: string[], values: object) => {
  headers = getHeaders();
  let lastError: any = null;
  for (const route of routes) {
    try {
      const response = await api.post(route, values, headers);
      persistAccessToken(response?.data);
      return response;
    } catch (err: any) {
      lastError = err;
    }
  }
  throw lastError;
};

const getAdminStudents = async () => {
  try {
    const response = await getWithFallbackRoutes([
      adminStudentsEndPoint(),
      "/api/v1/admin/all-students",
    ]);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const searchAdminStudents = async (query: string) => {
  try {
    const trimmed = query.trim();
    if (!trimmed) {
      return await getAdminStudents();
    }
    const response = await getWithFallbackRoutes([
      adminStudentSearchEndPoint(trimmed),
      `/api/v1/admin/search/${encodeURIComponent(trimmed)}`,
    ]);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const getAdminStudentById = async (studentId: string) => {
  try {
    const response = await getWithFallbackRoutes([
      adminStudentDetailsEndPoint(studentId),
      `/api/v1/admin/single-student/${studentId}`,
      `/api/v1/admin/students/${studentId}`,
    ]);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const getAdminCounsellors = async () => {
  try {
    const response = await getWithFallbackRoutes([
      adminCounsellorsEndPoint(),
      "/api/v1/admin/counselors",
    ]);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const transferStudentAdvisor = async (values: object) => {
  try {
    const response = await postWithFallbackRoutes(
      [
        adminStudentTransferEndPoint(),
        "/api/v1/admin/student/transfer",
      ],
      values
    );
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getMemberDetails = async () => {
  headers = getHeaders();
  try {
    const response = await api
      .get(memberEndPoint(), headers)
      .then((res) => res?.data);
      if (response.data && response.data?.AccessToken ) {
        localStorage.setItem("_auth_token", response.data?.AccessToken);
      }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const allstudentDetails = async (name: string, values: object) => {
  headers = getHeaders();
  try {
    const response = await api
      .post(studentDetails(name), values, headers)
      .then((res) => res?.data);
      if (response.data && response.data?.AccessToken ) {
        localStorage.setItem("_auth_token", response.data?.AccessToken);
      }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const newstudentDetails = async (values: object) => {
  headers = getHeaders();
  try {
    const response = await api
      .post(newStudentsEndPoint(), values, headers)
      .then((res) => res?.data);
      if (response.data && response.data?.AccessToken ) {
        localStorage.setItem("_auth_token", response.data?.AccessToken);
      }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const verifyUserOtp = async (values: object) => {
  headers = getHeaders();
  try {
    const response = await api.post(
      verifyUserEndPoint(),
      values,
      headers
    );
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    dispatch(
      setPopup({
        show: true,
        data: {
          container: {
            name: "error",
            data: response.data.message,
            dimensions: {
              width: "250px",
              // show:"none"

            },
          },
          type: "custom",
        },
      })
    );
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getStudentDetails = async (studentId: string) => {
  try {
    const response = await api
      .get(studentDetailsEndPoint(studentId), getHeaders())
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const switchStudentActivity = async (values: object) => {
  try {
    const response = await api.post(switchStageEndPoint(), values, getHeaders());
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const coordinatorSwitchStage = async (values: object) => {
  try {
    const response = await api.post(
      coordinatorStatusSwitchEndPoint(),
      values,
      headers
    );
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const newApplicationApproval = async (values: object) => {
  try {
    const response = await api.post(approvalEndPoint(), values, headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const recommedUniversity = async (values: object) => {
  try {
    const response = await api.post(
      recommendUniversityEndPoint(),
      values,
      headers
    );
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const hiderecommedUniversity = async (values: object) => {
  try {
    const response = await api.post(
      deleteRecommendationEndPoint(),
      values,
      headers
    );
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getSearchUniversityDetails = async (
  search: string,
  page: number,
  perPage: number,
  institutions: number,
  universities: number,
  disciplines: number,
  subDisciplines: number,
  location: number
) => {
  headers = getHeaders();
  try {
    const response = await api
      .get(
        searchUniversityEndPoint(
          search,
          page,
          perPage,
          institutions,
          universities,
          disciplines,
          subDisciplines,
          location
        ),
        headers
      )
      .then((res) => res?.data);
      if (response.data && response.data?.AccessToken ) {
        localStorage.setItem("_auth_token", response.data?.AccessToken);
      }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getSingleUniversity = async (universityId: any, currency: any) => {
  try {
    const response = await api.get(
      singleUniversityEndpoint(universityId, currency)
    );
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getSingleCourse = async (courseId: string, currency: any) => {
  try {
    // const { data } = await api.get(singleCourceEndpoint(courseId));
    const response = await api.get(singleCourceEndpoint(courseId, currency));
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getAlllistings = async (name: string, values: object, signal?: AbortSignal) => {
  console.log("Get Listing",name,values);
  headers = getHeaders();
  try {
    const response = await api
      .post(allListingsEndPoint(name), values, headers)
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const addChecklist = async (values: object) => {
  try {
    const response = await api.post(addToChecklistEndPoint(), values, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const editChecklist = async (values: object) => {
  try {
    const response = await api.post(editChecklistEndPoint(), values, headers);
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const googleAuthentication = async () => {
  try {
    const response = await api.get(googleFirstTimeCalenderEndpoint(), {
      withCredentials: true,
    });
    // console.log(response);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const getGoogleCalendarEvents = async () => {
  try {
    const response = await api
      .get(googleCalenderEventsEndpoint(), headers)
      .then((res) => res?.data);
      console.log(response)
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const sendGooglecode = async (code:string) => {
  try {
    const response = await api.get(googlecodeCalenderEndpoint(code), {
      withCredentials: true,
    });
    // console.log(response);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const cancellation= async (values:object) => {
  try {
    const response = await api.post(cancellationEndPoint(), values, headers);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const forgotPswdOtp = async (values: object) => {
  headers = getHeaders();
  function sanitizeValues(data: any) {
    return { email: data.email };
  }
  try {
    const response = await api.post(
      sendOTPEndPoint(),
      sanitizeValues(values),
      headers
    );
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const verifyForgotPswdOtp = async (values: object) => {
  headers = getHeaders();
  function sanitizeValues(data: any) {
    return { email: data.email, otp: data.otp, password: data.password };
  }
  try {
    const response = await api.post(
      verifyOTPEndPoint(),
      sanitizeValues(values),
      headers
    );
    if (response.data && response.data?.AccessToken ) {
      localStorage.setItem("_auth_token", response.data?.AccessToken);
    }
    dispatch(
      setPopup({
        show: true,
        data: {
          container: {
            name: "error",
            data: response.data.message,
            dimensions: {
              width: "250px",

            },
          },
          type: "custom",
        },
      })
    );
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const suggestPackageRoute= async (values:object) => {
  try {
    console.log("Package Headers",getHeaders());
    const response = await api.post(suggestPackageEndPoint(), values, getHeaders());
    dispatch(
      setPopup({
        show: true,
        data: {
          container: {
            name: "error",
            data: response.data.message,
            dimensions: {
              width: "250px",
            },
          },
          type: "custom",
        },
      })
    );
    return response;
    
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
//chats
const seenMessageDetails = async (roomId: string) => {
  try {
    const response = await api
      .get(seenEndPoint(roomId), headers)
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getNewChatsUsingSearch = async (searchTerm: string) => {
  try {
    const response = await api
      .get(searchChatsEndPoint(searchTerm), headers)
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

// to get chatid
const postingNewChatOrRetrivingOldChat = async (studentId: string) => {
  try {
    const response = await api
      .get(postRetriveChatEndPoit(studentId), headers)
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

// fetch all chats get function
const fetchAllChats = async () => {
  try {
    const response = await api.get(fetchChatsEndPoint(), headers);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

// fetch all messages
const fetchAllMessages = async (chatId: string) => {
  try {
    const response = await api
      .get(fetchAllMsgsEndPoint(chatId), headers)
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const communicationMessage = async (values: object) => {
  try {
    const response = await api.post(postMessageEndPoint(), values, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};
const getDocfromChat = async (id: string) => {
  try {
    const response = await api.get(chatDocsDownloadEndPoint(id), {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "multiform/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    // .then((preview) => preview);
    const url = new Blob([response.data]);
    return window.URL.createObjectURL(url);
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const revertDecision = async (values:object) => {
  try {
    const response = await api.post(revertDecisionEndPoint(), values, headers);
    return response;
  }catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

const result = async (values:object) => {
  try {
    const response = await api.post(resultEndPoint(), values, headers);
    return response;
  }catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};

export const getFilterOptions = async (name: string, values: object) => {
  headers = getHeaders();
  try {
    const response = await api
      .post(facetEndPoint(name), values, headers)
      .then((res) => res?.data);
    return response;
  } catch (err: any) {
    const errorResponse = handleApiError(err);
    throw errorResponse;
  }
};


export {
  authenticateLogin,
  allstudentDetails,
  getMemberDetails,
  getStudentDetails,
  switchStudentActivity,
  newApplicationApproval,
  recommedUniversity,
  getSearchUniversityDetails,
  getAlllistings,
  addChecklist,
  getDocfromChat,
  editChecklist,
  coordinatorSwitchStage,
  seenMessageDetails,
  communicationMessage,
  fetchAllMessages,
  fetchAllChats,
  postingNewChatOrRetrivingOldChat,
  getNewChatsUsingSearch,
  revertDecision,
  result,
  googleAuthentication,
  getGoogleCalendarEvents,
  cancellation,
  suggestPackageRoute,
  forgotPswdOtp,
  verifyForgotPswdOtp,
  sendGooglecode,
  newstudentDetails,
  hiderecommedUniversity,
  verifyUserOtp,
  getSingleCourse,
  getSingleUniversity,
  createBlog,
  createCountry,
  createTeam,
  createUser,
  updateUser,
  editCountry,
  deleteCountry,
  getAdminStudents,
  searchAdminStudents,
  getAdminStudentById,
  getAdminCounsellors,
  transferStudentAdvisor,
};
